import React, { useRef } from "react";
import { Box } from "@mui/material";
import Grid from "@mui/material/Grid2";

import { ModalRef } from "@shared/components";
import { ChangePasswordModal } from "../ChangePasswordModal";

import { UserFormProps } from "./types";
import { BasicFields, AdditionalFields, PermissionFields } from "./fields";

export const UserForm = React.memo(({ isEditing }: UserFormProps) => {
  const changePasswordModalRef = useRef<ModalRef>(null);

  return (
    <>
      <Box
        component="form"
        sx={{ display: "flex", flexDirection: "column" }}
        autoComplete="off"
      >
        <Grid container spacing={4}>
          <Grid size={{ xs: 12 }}>
            <BasicFields changePasswordModalRef={changePasswordModalRef} isEditing={isEditing} />
          </Grid>

          <Grid size={{ xs: 12 }}>
            <AdditionalFields />
          </Grid>

          <Grid size={{ xs: 12 }}>
            <PermissionFields />
          </Grid>
        </Grid>
      </Box>

      <ChangePasswordModal modalRef={changePasswordModalRef} />
    </>
  );
});
